import atimg1 from '../images/team/img-1.jpg'
import atimg2 from '../images/team/img-2.jpg'
import atimg3 from '../images/team/img-3.jpg'
import atimg4 from '../images/team/img-4.jpg'


const Attorneys = [
   {
      Id: '1',
      AtImg: atimg1,
      name: 'Michel Troat',
      slug: 'Michel-Troat',
      title: 'Family Consultant',
   },
   {
      Id: '2',
      AtImg: atimg2,
      name: 'Jonathon Danial',
      slug: 'Jonathon-Danial',
      title: 'Business Lawyer',
   },
   {
      Id: '3',
      AtImg: atimg3,
      name: 'Muli Overla',
      slug: 'Muli-Overla',
      title: 'Political Expert',
   },
   {
      Id: '4',
      AtImg: atimg4,
      name: 'Oncon Lucy',
      slug: 'Oncon-Lucy',
      title: 'Family Lawyer',
   },
   {
      Id: '5',
      AtImg: atimg2,
      name: 'Jane Cooper',
      slug: 'Jane-Cooper',
      title: 'Divorce Lawer',
   }

]

export default Attorneys;